export default "<p  class =\"errorcls\">\r\n    You don't have access to this application. Contact\r\n    Application administrator\r\n  </p>"